// helper to handle media library pro UI component

/**
 * Returns the data that will be submitted to the server from a collection
 *
 * @param {Element} container
 * @param {string} collectionName
 */
function getFilesDataFromMediaCollection(container, collectionName) {
	const mediaData = Array.from(
		container.querySelectorAll(`input[name^='${collectionName}']`)
	)
		// Break down its components
		.map(input => {
			// Name its expected to have the format collection[uuid][property]
			const name = input.name;
			const value = input.value;

			// Remove collection name
			const uuidNamePair = name.replace(collectionName, '');

			const uuidNamePairSplit = uuidNamePair.split('][');

			const uuid = uuidNamePairSplit[0].substring(1);
			const property = uuidNamePairSplit[1].substring(0, uuidNamePairSplit[1].length - 1);

			return {
				uuid,
				property,
				value,
			}
		})
		// Group by uuid
		.reduce((result, components) => {
			if (!result[components.uuid]) {
				result[components.uuid] = {};
			}

			result[components.uuid][components.property] = components.value;

			return result;
		}, {});

	// Turn into an array
	const resultsArray = [];

	Object.values(mediaData).forEach(data => {
		console.log(data);
		resultsArray.push(data)
	})

	return resultsArray;

}

export {getFilesDataFromMediaCollection}
